// extracted by mini-css-extract-plugin
module.exports = {"button":"_3AYpC","yellow":"_17pgH","constructor":"dd6gr","europe":"_14Jai"};